module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image4m.b66dd3b5.jpg";